import * as fb from './firebase'
import store from '@/store'

export const deleteUser = async function(uid) {
  let userRef = fb.usersCollection.doc(uid)
  const userProfile = await userRef.get()
  const userData = userProfile.data()
  if (store.state.isAdmin || store.state.userProfile?.uid === uid) {
    if (confirm(`Are you sure you want to delete user ${userData.firstName} ${userData.lastName}?`) == true) {
      userRef.delete()
      return true
    }
    else {
      return false
    }
  }
  else {
    return(new Error('You do not have privileges to do that'))
  }
}

export const getClientEmail = async function (uid) {
  const getUser = fb.funcs.httpsCallable('getUser')
  let email = ''
  await getUser({ uid }).then(result => {
    email = result.data.email
  })
  return email
}

export const isClientEmailVerified = async function (uid) {
  const getUser = fb.funcs.httpsCallable('getUser')
  let isVerified = ''
  await getUser({ uid }).then(result => {
    isVerified = result.data.emailVerified
  })
  return isVerified
}

export const getClientPaymentMethods = async function (stripeCustomerId) {
  let methods
  await fb.funcs.httpsCallable('getPaymentMethods')({ stripeCustomerId }).then(result => {
    methods = result.data
  })
  return methods
}